import { render, staticRenderFns } from "./product-management.vue?vue&type=template&id=1c2e4694&scoped=true"
import script from "./product-management.vue?vue&type=script&lang=js"
export * from "./product-management.vue?vue&type=script&lang=js"
import style0 from "./product-management.vue?vue&type=style&index=0&id=1c2e4694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e4694",
  null
  
)

export default component.exports